module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/thumbs/1-3f57db663b34bea868f9d7ea5a7c0fa5.webp";